<div class="sia-loading" *ngIf="isShown">
  <img src="/assets/images/ihm_loading.gif" />
  
</div>
